/** Replace `{token}` placeholders in a copy string. */
export function formatCopy(
  template: string,
  values: Record<string, string | number>,
): string {
  return template.replace(/\{(\w+)\}/g, (match, key: string) =>
    key in values ? String(values[key]) : match,
  );
}

/** Interpolate public data into trusted, bundled HTML copy; escape each value. */
export function formatCopyHtml(
  template: string,
  values: Record<string, string | number>,
): string {
  const escaped = Object.fromEntries(Object.entries(values).map(([key, value]) => [
    key,
    String(value).replace(/[&<>"']/g, (char) => ({
      "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;",
    })[char]!),
  ]));
  return formatCopy(template, escaped);
}
